module.exports = "https://web-assets-production.autolist.com/_next/static/images/springfield-mo-ea2dbc76f7ae7237b373a5a357b2eb6f.jpg";